import { ReactNode } from 'react';

interface HeroProps {
  title: string;
  description?: string;
  image: string;
  children?: ReactNode;
  size?: 'large' | 'small';
}

export function Hero({ title, description, image, children, size = 'small' }: HeroProps) {
  return (
    <div className="relative bg-emory-blue">
      <div className="absolute inset-0">
        <img
          src={image}
          alt={title}
          className="h-full w-full object-cover opacity-20"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-r from-emory-blue/90 via-emory-blue/70 to-emory-light-blue/60" />
      <div className="relative mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
        <div className={`py-12 ${size === 'large' ? 'md:py-24' : 'md:py-16'}`}>
          <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-4">
            {title}
          </h1>
          {description && (
            <p className="text-lg md:text-xl text-white/90 max-w-3xl leading-relaxed">
              {description}
            </p>
          )}
          {children}
        </div>
      </div>
    </div>
  );
}